<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent debajo"
    :class="{'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute}"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <div class="top-header">
          <div style="display:flex; flex-direction:row; align-items: flex-end;">
            <img
              src="https://florette-static-pro.azureedge.net/assets/images/logo_tipografico_verde.png"
              width="140px"
            />
            <span class="portal-name title-florette">Panel Reclamaciones</span>
          </div>
          <div class="top-header-title">
            <h3 class="md-title">{{$route.name}}</h3>
          </div>
        </div>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{toggled: $sidebar.showSidebar}"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <md-list-item v-if="empleado != null">
              <img :src="getAvatar()" class="avatar" alt="avatar" />
              <p class="user-container">{{empleado.nombre}}</p>
            </md-list-item>

            <md-list-item to="/">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>

            <li class="md-list-item">
              <a
                href="#"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>notifications</md-icon>
                      <span class="notification">{{notifications}}</span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li v-if="notifications > 0">
                        <a href="#">Hay {{notifications}} reclamaciones nuevas</a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import { apiServer, staticServer, florette_web } from "@/globalVars.js";

export default {
  data() {
    return {
      notifications: 0,
      timer: "",
    };
  },
  computed: {
    empleado() {
      return this.$store.state.empleado.current;
    },
    user() {
      return this.$store.state.authentication.user;
    },
  },
  methods: {
    getAvatar() {
      return `https://florette-static-pro.azureedge.net/assets/empleados/${this.empleado.photo}`;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    updateNotifications() {
      fetch(apiServer + "/reclamacion/nuevas")
        .then((response) => response.json())
        .then((data) => {
          this.notifications = data.total;
        });
    },
  },
  mounted() {
    this.$store.dispatch("empleado/getInfo");
    this.updateNotifications();
    this.timer = setInterval(this.updateNotifications, 10000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.avatar {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 5px;
}
.user-container {
  margin-block-start: 0 !important;
  margin-block-end: 0 !important;
  padding-left: 10px;
}
.portal-name {
  margin: 0px;
  font-size: 2em;
  padding-left: 10px;
  padding-bottom: 2px;
}
.md-toolbar-row {
  align-items: flex-start;
}
.debajo{
  z-index: 0;
}
</style>